import { createAction } from '@reduxjs/toolkit'

import { curryActionForPage } from 'helpers/curry'
import { ActionForPagePayload } from 'types'

// Mount Page
export const mountPageRequest =
    createAction<ActionForPagePayload<object>>('MOUNT_PAGE_REQUEST')
export const mountPageSuccess =
    createAction<ActionForPagePayload<unknown>>('MOUNT_PAGE_SUCCESS')
export const mountPageFailure =
    createAction<ActionForPagePayload<{ message: string }>>(
        'MOUNT_PAGE_FAILURE'
    )

export const makeMountPageRequest = curryActionForPage(mountPageRequest)
export const makeMountPageSuccess = curryActionForPage(mountPageSuccess)

// Unmount Page
export const unmountPageRequest = createAction<ActionForPagePayload<unknown>>(
    'UNMOUNT_PAGE_REQUEST'
)
export const makeUnmountPageRequest = curryActionForPage(unmountPageRequest)

// Fetch data
export const fetchPageDataRequest = createAction<ActionForPagePayload<unknown>>(
    'FETCH_PAGE_DATA_REQUEST'
)
export const fetchPageDataSuccess = createAction<ActionForPagePayload<unknown>>(
    'FETCH_PAGE_DATA_SUCCESS'
)
export const fetchPageDataFailure = createAction<
    ActionForPagePayload<{ message: string }>
>('FETCH_PAGE_DATA_FAILURE')
